export const ARTICLES_TRENDING_REQUEST = 'ARTICLES_TRENDING_REQUEST';
export const ARTICLES_TRENDING_FAILURE = 'ARTICLES_TRENDING_FAILURE';
export const ARTICLES_TRENDING_SUCCESS = 'ARTICLES_TRENDING_SUCCESS';
export const TAGS_SUCCESS = 'TAGS_SUCCESS';
export const TAGS_FAILURE = 'TAGS_FAILURE';